import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@massilia/ui';
import { IconInput } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { useState } from 'react';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldError } from './field-error';
export default function PasswordField({ containerClassName, errorAsString = false, ...props }) {
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    const [showPassword, setShowPassword] = useState(false);
    return (_jsxs("div", { className: cn('flex flex-1 flex-col gap-1', containerClassName), children: [_jsx(IconInput, { "aria-invalid": errors.length > 0, buttonRightCallBack: () => setShowPassword((prev) => !prev), buttonRightIcon: showPassword ? EyeOff : Eye, icon: Lock, onBlur: field.handleBlur, onChange: (e) => field.handleChange(e.target.value), type: showPassword ? 'text' : 'password', value: field.state.value ?? '', ...props }), _jsx(FieldError, { asString: errorAsString, errors: errors })] }));
}
